<template>
  <div>
    <!-- 新增管理用户弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      class="add_roll-dialog"
      :title="$t('salespersonMgt.addMgtUserTitle')"
      width="70%"
      :visible.sync="isOpenAddMgtUserDialog"
      :before-close="closeAddMgtUserDialog"
      append-to-body
      center
    >
      <p0438 ref="p0438Ref" :pageNo="3" :marketingUserWatch="marketingUserWatch" :salesperson="salesPerson"></p0438>
    </el-dialog>
      <el-row>
        <div style="display: inline-block;" class="mainDiv">
          <el-form
            :model="queryForm"
            label-position="right"
            ref="queryFormRef"
            label-width="120px"
            style="width:100%;"
            class="systemFont1"
          >
            <el-col :span="1">
              <!-- 新增用户 -->
              <el-button class="submitButton" type="submit" @click="addManagementUser()">{{
                $t("salespersonMgt.addMgtUser")
              }}</el-button>
            </el-col>
            <el-col :span="11" :offset="4">
              <!-- 个人用户检索入力框 -->
              <el-form-item
                :label="$t('salespersonMgt.personalUser')"
                prop="queryCriteria"
              >
                <el-input
                  type="text"
                  size="small"
                  maxlength="60"
                  v-model="queryForm.queryCriteria"
                  clearable
                  :placeholder="$t('salespersonMgt.searchPlaceholder')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <!-- 查询 -->
              <img
                src="../../../assets/p0322Query.svg"
                width="36px"
                height="36px"
                style="cursor: pointer; padding-left: 16px;"
                @click="getMgtUserList(true)"
              />
            </el-col>
          </el-form>
        </div>
      </el-row>
    <!-- 用户列表 -->
    <div class="tableDiv">
      <el-table
        ref="mgtUserDtlTblRef"
        :data="mgtUserList"
        v-loading="mgtUserLoading"
        tooltip-effect="dark"
        style="width:95%;margin:auto"
      >
        <!-- 姓名-->
        <el-table-column
          prop="name"
          :label="$t('salespersonMgt.nameZh')"
          align="left"
          min-width="145px"
          fixed="left"
        ></el-table-column>
        <!-- 英文姓名-->
        <el-table-column
          prop="nameEn"
          :label="$t('salespersonMgt.nameEn')"
          align="left"
          min-width="160px"
        ></el-table-column>
        <!-- 昵称-->
        <el-table-column
          prop="nickname"
          :label="$t('salespersonMgt.nickname')"
          align="left"
          min-width="120px"
        ></el-table-column>
        <!-- 注册邮箱-->
        <el-table-column
          prop="registerEmail"
          :label="$t('salespersonMgt.registerEmail')"
          align="left"
          min-width="270px"
        ></el-table-column>
        <!-- 注册手机-->
        <el-table-column
          prop="registerPhone"
          :label="$t('salespersonMgt.registerPhone')"
          align="center"
          min-width="130px"
        ></el-table-column>
        <!-- 关联公司-->
        <el-table-column
          prop="existingCompany"
          :label="$t('salespersonMgt.existingCompany')"
          align="left"
          min-width="265px"
        ></el-table-column>
        <!-- 职位-->
        <el-table-column
          prop="position"
          :label="$t('salespersonMgt.position')"
          align="left"
          min-width="180px"
        ></el-table-column>
        <!-- 操作 -->
        <el-table-column
          :label="$t('common.operation')"
          align="center"
          min-width="65px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="text" @click="mgtUserDelete(scope.row)">{{
              $t("common.delete")
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row style="text-align: right; margin: 20px 60px">
        <el-col :span="24">
          <div class="block">
            <el-pagination
              @size-change="mgtUserSizeChange"
              @current-change="mgtUserCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import p0438 from '../../Marketing/MarketingMgt/commonPg/P0438';
export default {
  props: {
    salesPerson: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      // 管理用户一览数据
      mgtUserList: [],
      // 用户列表载入状态
      mgtUserLoading: false,
      // 打开新增管理用户弹框
      isOpenAddMgtUserDialog: false,
      // 销售人员新增刷新判断
      marketingUserWatch: false,
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 10,
      // 总数
      total: 0,
      // 查询条件
      queryForm: {
        queryCriteria: ""
      },
      // 检索条件保持变量
      tmpQueryStr: {
        queryCriteria: ""
      }
    };
  },
  components: {
    p0438
  },
  methods: {
    // 管理人员一览取得
    getMgtUserList(val) {
      this.mgtUserLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
      }
      // 换页时，检索条件还原
      this.queryForm = this.tmpQueryStr;
      // 销售人员一览取得
      let url = "/api/salespersonMgt/getMgtUserList";
      this.$http
        .post(
          url,
          qs.stringify({
            ...this.queryForm,
            salesPerson: this.salesPerson,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          this.mgtUserLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.mgtUserList = response.data.data;
            this.total = this.mgtUserList.length > 0 ? this.mgtUserList[0].total : 0;
          } else {
            this.mgtUserList = [];
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.mgtUserLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 新增管理用户
    addManagementUser() {
      // 刷新弹窗
      this.marketingUserWatch = !this.marketingUserWatch;
      this.isOpenAddMgtUserDialog = true;
    },
    // 管理用户删除
    mgtUserDelete(rowVal) {
      // 删除管理用户
      this.$confirm(this.$t("salespersonMgt.delMgtUserConfirm"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(() => {
          // 删除管理用户
          let url = "/api/salespersonMgt/deleteMgtUser";
          this.$http
          .post(
            url,
            qs.stringify({
              userId: rowVal.userId,
              updateUser: localStorage.getItem("userId")
            })
          )
          .then(response => {
            console.log(response.data);
            if (response.data.code === 200) {
              if(this.mgtUserList.length > 1) {
                // 该页数据超过一件时，重新筛选当页数据
                this.getMgtUserList(false);
              } else {
                // 该页数据仅一件时，重新从第一页筛选数据
                this.getMgtUserList(true);
              }
              this.$message.success(response.data.data);
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
        }).catch(() => {});
    },
    // 每页数据条数设定
    mgtUserSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.mgtUserList == undefined ||
        this.mgtUserList.length <= 0
      ) {
        return;
      }
      this.getMgtUserList(false);
      // console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    mgtUserCurrentChange(val) {
      this.currentPage = val;
      this.getMgtUserList(false);
      // console.log(`当前页: ${val}`);
    },
    // 画面数据初始化
    resetUserMgt() {
      this.mgtUserList = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.total = 0;
      this.queryForm.queryCriteria = "";
    },
    // 新增管理用户弹窗关闭
    closeAddMgtUserDialog() {
      this.isOpenAddMgtUserDialog = false;
      this.getMgtUserList(true);
    },
  },
  mounted() {
    this.getMgtUserList(true);
  }
};
</script>

<style lang="scss" scoped>
.mainDiv {
  width: 90%;
  margin: 0 auto;
  display: flex;
}
.tableDiv {
  margin-top: 10px;
  min-height:360px;
  padding-bottom: 16px;
}
.submitButton {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>>.el-divider--horizontal{
  margin: 14px 0;
}
.add_roll-dialog{
  >>> .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 160px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/P0432.vue